import React, { useEffect, useState } from "react";
import {
  Typography,
  Row,
  Col,
  Table,
  Button,
  Space,
  message,
  Spin,
  Switch,
} from "antd";
import { CopyOutlined, EyeOutlined, MailOutlined } from "@ant-design/icons";
import { useNavigate } from "react-router-dom";
import dataService from "../networks/api/service/dataService";
import CustomTable from "../components/TableComponent/CustomTable";
import colors from "../assets/styles/colour";

const { Title } = Typography;

const FormLists = () => {
  const [surveys, setSurveys] = useState([]);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  const getFormLists = async () => {
    try {
      const response = await dataService.getAllForm();
      if (response.code === 200) {
        setSurveys(response.data);
      } else {
        message.error("Something went wrong while getting form details");
      }
    } catch (e) {
      message.error("Error fetching data");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getFormLists();
  }, []);

  const handleCopyId = (id) => {
    navigator.clipboard
      .writeText(`https://nirmalya.store/karyalay/survey-form/${id}`)
      .then(() => message.success("Survey ID copied to clipboard"))
      .catch(() => message.error("Failed to copy ID"));
  };

  const handleStatusChange = async (checked, surveyId) => {
    try {
      //   const updatedSurvey = {
      //     ...surveys.find((survey) => survey._id === surveyId),
      //     status: checked ? "Active" : "Inactive",
      //   };

      const data = {
        status: checked ? "Active" : "Inactive",
      };
      const response = await dataService.updateSurveyStatus(surveyId, data);
      if (response.code === 200) {
        getFormLists();
        message.success(`Survey is now ${checked ? "Active" : "Inactive"}`);
      } else {
        message.error("Failed to update survey status");
      }
    } catch (e) {
      message.error("Error updating status");
    }
  };

  const columns = [
    {
      title: "Sl. No.",
      dataIndex: "index",
      key: "index",
      render: (text, record, index) => index + 1,
      width: "10%",
      responsive: ["md"],
    },
    {
      title: "Title",
      dataIndex: "title",
      key: "title",
      width: "40%",
      render: (text) => <strong>{text}</strong>,
    },
    {
      title: "Status",
      dataIndex: "status",
      key: "status",
      width: "20%",
      render: (text, record) => (
        <Switch
          checked={text === "Active"}
          onChange={(checked) => handleStatusChange(checked, record._id)}
          style={{ width: "50px" }}
        />
      ),
    },
    {
      title: "Actions",
      dataIndex: "_id",
      key: "actions",
      width: "30%",
      render: (text, record) => (
        <Space size="middle">
          <Button
            type="link"
            onClick={() => handleCopyId(text)}
            icon={<CopyOutlined />}
            style={{ color: "#1890ff" }}
          >
            Copy Link
          </Button>
          <Button
            type="link"
            onClick={() =>
              navigate(`/login/send-message`, {
                state: { surveyData: record },
              })
            }
            icon={<MailOutlined />}
            style={{ color: "#1890ff" }}
          >
            Send Mail
          </Button>
          <Button
            type="link"
            onClick={() => navigate(`/login/list-of-surveys/${record._id}`)}
            icon={<EyeOutlined />}
            style={{ color: "#1890ff" }}
          >
            View Response
          </Button>
        </Space>
      ),
    },
  ];

  const tableData = surveys?.map((survey, index) => ({ ...survey, index }));

  return (
    <Row justify="center">
      <Col>
        <Title
          level={3}
          style={{
            textAlign: "center",
            color: colors.sidebarText,
            marginBottom: "1rem",
          }}
        >
          Survey List
        </Title>

        {loading ? (
          <Spin
            size="large"
            tip="Loading surveys..."
            style={{ display: "block", margin: "0 auto" }}
          />
        ) : (
          <CustomTable
            dataSource={tableData}
            columns={columns}
            rowKey="_id"
            pagination={{ pageSize: 5 }}
            bordered
            size="middle"
            style={{
              boxShadow: "0 4px 10px rgba(0, 0, 0, 0.1)",
              borderRadius: "8px",
              backgroundColor: "#fff",
              overflowX: "auto",
              width: "100%",
            }}
            scroll={{ x: 500 }} // Enables horizontal scroll on smaller screens
          />
        )}
      </Col>
    </Row>
  );
};

export default FormLists;
